let apiUrl = process.env.VUE_APP_API + process.env.VUE_APP_API_OM;
let pmUrl = process.env.VUE_APP_API + process.env.VUE_APP_API_PM;

class OM {
  static uploadOnlineRefundATMAccount(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/uploadOnlineRefundATMAccount`, params, {
      headers: {
        authorization: `Bearer ${token}`,
        ContentType: "application/form-data"
      }
    });
  }

  static applyOnlineRefundTickets(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/applyOnlineRefundTickets`, params, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static getOnlineRefundTickets(orderNum) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getOnlineRefundTickets?orderNum=${orderNum}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static getPurchaseInfo(orderId) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${pmUrl}/getPurchaseInfo?orderId=${orderId}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static getOrderInfo(orderId) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getOrderInfo?orderId=${orderId}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static paymentProcess(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/paymentProcess`, params, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static getUserCCInfo() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(
      `${apiUrl}/cc/getUserCCInfo`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`
        }
      }
    );
  }

  static updateCCInfo() {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(
      `${apiUrl}/cc/updateCCInfo`,
      {},
      {
        headers: {
          authorization: `Bearer ${token}`
        }
      }
    );
  }

  static getAllPurchases(num) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(
      `${pmUrl}/getAllPurchases${num ? `?orderNum=${num}` : ""}`,
      {
        headers: {
          authorization: `Bearer ${token}`
        }
      }
    );
  }

  static getAllOrders(num) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.get(`${apiUrl}/getAllOrders${num ? `?orderNum=${num}` : ""}`, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }

  static updateApplicant(params) {
    let token = JSON.parse(Cookies.get("user"))
      ? JSON.parse(Cookies.get("user")).access_token
      : "";
    return axios.post(`${apiUrl}/applicant/update`, params, {
      headers: {
        authorization: `Bearer ${token}`
      }
    });
  }
}

export default OM;
